<template>
  <div :class="panelMode ? 'p-3' :'container'">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-2">
        <h3 style="padding-right: 60px">Endre rekkefølgen av valg og tillegg i gruppen</h3>
        <div class="dragndrop-info">
        <!-- One sentence per pointer: a finger has to hold first, a mouse does not, and telling
             either one the other's gesture is how «sorteringen virker ikke» starts. -->
        <span class="bo_pointer-fine">Dra og slipp radene for å endre rekkefølgen på valg og tillegg i gruppen.</span>
        <span class="bo_pointer-coarse">Hold fingeren på en rad til den løfter seg, og dra den dit du vil — slik endrer
          du rekkefølgen på valg og tillegg i gruppen. Sveiper du raskt, ruller listen i stedet.</span>
        Til slutt trykker du på &laquo;Lagre&raquo; nederst.
      </div>

        <ul id="addOnsList" class="bo_categoriesList">
          <li v-for="addOn in addOns" :key="addOn.id" :id="addOn.id" class="category-row">
            <span class="bo_drag-handle"><font-awesome-icon :icon="['fas', 'grip-lines']"/></span>
            <span class="bo_row-label">{{ addOn.menuNr }} {{ addOn.name }}</span>
            <span class="bo_row-move">
              <button type="button" class="icon-btn" aria-label="Flytt opp" @click="moveRowUp($event)"><font-awesome-icon :icon="['fas', 'chevron-up']"/></button>
              <button type="button" class="icon-btn" aria-label="Flytt ned" @click="moveRowDown($event)"><font-awesome-icon :icon="['fas', 'chevron-down']"/></button>
            </span>
          </li>
        </ul>

        <div class="bo_savebtn_container">
          <hr/>
          <button type="button" class="bo_btn" @click="saveOrderOfAddOns()">Lagre</button>
        </div>
      </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ProductService from "@/services/product/ProductService";
import Sortable from 'sortablejs';
import sortableOptions from "@/util/SortableOptions";
import { moveRowUp, moveRowDown } from "@/util/RowReorder";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false },
    addOnGroupIdProp: { type: String, default: '' }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,
      addOns : []
    };
  },
  mounted() {
    let addOnGroupId = this.addOnGroupIdProp || this.$route.query.addOnGroupId;
    ProductService.getAddOnsOfAddOnGroup(addOnGroupId).then(
        (response) => {
          this.addOns = response.data;
          this.$nextTick(() => {
            let el = document.getElementById('addOnsList');
            Sortable.create(el, sortableOptions());
          });

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  methods: {
    // Reordering without a drag — see RowReorder.js for why these move the DOM.
    moveRowUp,
    moveRowDown,

   updateSortOrder(addOnId, sortOrder) {
      //console.log(sortOrder + ' : ' + addOnId);
      for (var i = 0; i < this.addOns.length; i++) {
        if (this.addOns[i].id == addOnId) {
          this.addOns[i].sortOrder = sortOrder;
          break; //Stop this loop, we found it!
        }
      }
    },
    saveOrderOfAddOns(){
     this.loading = true;

      let listAddOns = document.getElementById('addOnsList').getElementsByTagName('li');
      for (var i = 0; i < listAddOns.length; i++) {
        let li = listAddOns[i];
        let addOnId = li.getAttribute('id');
        this.updateSortOrder(addOnId, i);
      }

      ProductService.editAddOns(this.addOns).then(
          (response) => {
            if(response.data === "SUCCEEDED"){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Updating sortOrder of addOns failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
